import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.goodsSystem
import qs from 'qs'

/**
 * 固定渠道模块（供应商 + 货物类别，财务审批生效）——需求 FR-CH-01~04 / 5.1
 * 注意：以下接口路径为前端预留，具体以后端为准（TODO 待后端联调确认）
 */

// 固定渠道列表（分页，状态筛选：1草稿 2审批中 3生效 4已驳回）
export function getFixedChannelList(data) {
    return request({
        url: serviceName + `/fixed_channel_list`,
        method: 'post',
        data: data
    })
}

// 新增固定渠道（行政部 31 / 行政总监 48 创建）
export function addFixedChannel(data) {
    return request({
        url: serviceName + `/add_fixed_channel`,
        method: 'post',
        data: data
    })
}

// 修改固定渠道（草稿/驳回态可改）
export function updateFixedChannel(data) {
    return request({
        url: serviceName + `/update_fixed_channel`,
        method: 'post',
        data: data
    })
}

// 提交固定渠道审批（草稿 → 审批中）
export function submitFixedChannel(data) {
    return request({
        url: serviceName + `/submit_fixed_channel`,
        method: 'post',
        data: data
    })
}

// 删除固定渠道（草稿/驳回态可删）
export function deleteFixedChannel(data) {
    return request({
        url: serviceName + `/delete_fixed_channel`,
        method: 'post',
        data: data
    })
}

// 固定渠道待审批/已审批记录（财务 27 审批，func=2 未审批 / func=1 已审批）
export function fixedChannelApprovedList(data) {
    return request({
        url: serviceName + `/fixed_channel_approved_list` + '?' + qs.stringify(data),
        method: 'get',
        data: data
    })
}
